export default {
  settings: 'TEAMS_SETTINGS',
  updateSettings: 'TEAMS_SETTINGS_UPDATE',
};
